module.exports = __webpack_public_path__ + "img/bitpanda-dark.f177510d.png";